export const sendPaymentToChat = async (
  chat_id: string | undefined | number,
  order: any,
  WEB_APP_URL: string,
  insuranceType: string,
  vehicleInfo: string,
  datesAndDuration: string,
  locale: string,
  region?: string,
  category?: string
): Promise<any> => {
  const url = `${process.env.REACT_APP_WORKER_URL}/send-payment-link-to-chat`;
  const body = {
    chat_id,
    order,
    WEB_APP_URL,
    insuranceType,
    vehicleInfo,
    datesAndDuration,
    region,
    locale,
    category,
  };

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new Error(
        `Failed to send payment message: ${response.status} ${response.statusText}`
      );
    }

    return await response.json();
  } catch (error) {
    console.error('Error sending payment message:', error);
    throw error;
  }
};
